import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk';
import rootReducer  from './reducers.js'
import cloneDeep from 'lodash/cloneDeep'



const logger = store => next => action => {
  console.log('Redux - Dispatch ' + action.type, action)
  let result = next(action)
  const savedState = cloneDeep(store.getState())
  console.log('Redux - Next State', savedState )
  return result
}
/*
const crashReporter = store => next => action => {
  try {
    return next(action)
  } catch (err) {
    console.error('Caught an exception!', err)
    throw err
  }
}
*/
// Redux with redux-devtools in chrome/firefox
//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
//const appStore = createStore(rootReducer, /* preloadedState, */ composeEnhancers(applyMiddleware(  crashReporter, thunk, logger,  )));

// TODO Configure Redux for Production ?

if ( typeof createStore === 'undefined') throw 'createStore' 
if ( typeof rootReducer === 'undefined') throw 'rootReducer' 
if ( typeof applyMiddleware === 'undefined') throw 'applyMiddleware' 
if ( typeof thunk === 'undefined') throw 'thunk' 
if ( typeof logger === 'undefined') throw 'logger' 


const appStore = createStore(rootReducer, applyMiddleware(  thunk, logger ));

export function getStore() { return appStore };
